webpackJsonp([225901961288281],{

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mp-1.07a5c922.jpg";

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mp-2.738fae94.jpg";

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mp-3.03d531ab.jpg";

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-mp-4.47e6b7a2.jpg";

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Hero-mp.202765b3.jpg";

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Inbox-mp.7eb25a7e.jpg";

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mailmerge-mp.15018be7.jpg";

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Statistics-mp.92bd07ea.jpg";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MpQuery = undefined;
	
	var _Grid = __webpack_require__(5);
	
	var _Hero = __webpack_require__(13);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ProductBar = __webpack_require__(14);
	
	var _ProductBar2 = _interopRequireDefault(_ProductBar);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _DividerImage = __webpack_require__(17);
	
	var _DividerImage2 = _interopRequireDefault(_DividerImage);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OrderButton = __webpack_require__(18);
	
	var _OrderButton2 = _interopRequireDefault(_OrderButton);
	
	var _PricingContainer = __webpack_require__(19);
	
	var _PricingContainer2 = _interopRequireDefault(_PricingContainer);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _HeroMp = __webpack_require__(119);
	
	var _HeroMp2 = _interopRequireDefault(_HeroMp);
	
	var _InboxMp = __webpack_require__(121);
	
	var _InboxMp2 = _interopRequireDefault(_InboxMp);
	
	var _PhoneSecurity = __webpack_require__(40);
	
	var _PhoneSecurity2 = _interopRequireDefault(_PhoneSecurity);
	
	var _StatisticsMp = __webpack_require__(124);
	
	var _StatisticsMp2 = _interopRequireDefault(_StatisticsMp);
	
	var _MailmergeMp = __webpack_require__(123);
	
	var _MailmergeMp2 = _interopRequireDefault(_MailmergeMp);
	
	var _BackgroundMp = __webpack_require__(111);
	
	var _BackgroundMp2 = _interopRequireDefault(_BackgroundMp);
	
	var _BackgroundMp3 = __webpack_require__(112);
	
	var _BackgroundMp4 = _interopRequireDefault(_BackgroundMp3);
	
	var _BackgroundMp5 = __webpack_require__(113);
	
	var _BackgroundMp6 = _interopRequireDefault(_BackgroundMp5);
	
	var _BackgroundMp7 = __webpack_require__(114);
	
	var _BackgroundMp8 = _interopRequireDefault(_BackgroundMp7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    navcolour: {
	      backgroundColor: theme.colours.products.mp
	    },
	    text: {
	      width: "50vw",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      }
	    },
	    contentBox: {
	      minHeight: "100vh"
	    },
	    pricingContainer: {
	      width: "100%"
	    },
	    pricing: {
	      marginBottom: "5rem",
	      width: "35vw",
	      "@media (max-width: 823px)": {
	        marginBottom: "1rem",
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "3rem"
	        }
	      }
	    },
	    image: {
	      width: "700px",
	      "@media (max-width: 823px)": {
	        display: "none"
	      }
	    },
	    mobileImage: {
	      width: "325px",
	      "@media (min-width: 824px)": {
	        display: "none"
	      }
	    }
	  };
	};
	
	var NavTabs = [{
	  tabLink: "#features",
	  tabName: "Features"
	}, {
	  tabLink: "#pricing",
	  tabName: "Pricing"
	}, {
	  tabLink: "/tutorials",
	  tabName: "Tutorials"
	}, {
	  tabLink: "/faq",
	  tabName: "FAQ"
	}, {
	  tabLink: "/contact",
	  tabName: "Support"
	}];
	
	var MpPage = function MpPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ProductBar2.default,
	      {
	        className: classes.navcolour,
	        logoLink: "/mp",
	        logoSrc: "/mp-logo.svg"
	      },
	      NavTabs.map(function (tab) {
	        return _react2.default.createElement(_ProductBar.Tab, { key: tab.tabName, tabLink: tab.tabLink, tabName: tab.tabName });
	      })
	    ),
	    _react2.default.createElement(
	      _Hero2.default,
	      { hero: _HeroMp2.default, withBar: true },
	      _react2.default.createElement(
	        _Hero.HeroText,
	        null,
	        _react2.default.createElement(_Hero.HeroIcon, { src: "/uk-parliament.svg" }),
	        _react2.default.createElement(_HtmlContainer2.default, { content: data.HeroText.html })
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "features" },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _InboxMp2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _InboxMp2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMp2.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _PhoneSecurity2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _PhoneSecurity2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMp4.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _StatisticsMp2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _StatisticsMp2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMp6.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentSection.html })
	        ),
	        _react2.default.createElement(_Image2.default, { image: _MailmergeMp2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _MailmergeMp2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundMp8.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "pricing" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.pricingContainer },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.pricing },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.PricingSection.html })
	          )
	        ),
	        _react2.default.createElement(
	          _PricingContainer2.default,
	          null,
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstPricingChecklist.html }),
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondPricingChecklist.html }),
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdPricingChecklist.html })
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(_OrderButton2.default, {
	            eventlabel: "Clicked MP buy button",
	            mailinfo: "mailto:sales@electedtechnologies.com?subject=Caseworker.mp Sales Enquiry",
	            label: "Order Caseworker Now",
	            phonenumber: "0333 344 1225"
	          })
	        )
	      )
	    )
	  );
	};
	
	MpPage.propTypes = {
	  classes: _propTypes2.default.object,
	  data: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(MpPage);
	
	/* global graphql */
	
	var MpQuery = exports.MpQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mp-jsx-4ee9639445ce6588c70e.js